import script from "./DocumentEventModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentEventModal.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentEventModal.vue?vue&type=style&index=0&id=2d10ace5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d10ace5"]])

export default __exports__